import React, { Component } from 'react';
import axios from 'axios';
import DefaultAvatar from '../../../assets/images/default-avatar.png';

export default class UserCommentListPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            commentlist: [],
            needreply:[],
            recordingSelected: null
        }
        this.getBOTCommentList = this.getBOTCommentList.bind(this);
    }

    componentDidMount() {
        // Sử dụng param từ props để thực hiện các hành động cần thiết, ví dụ như gọi API
        const { param } = this.props;
        this.getBOTCommentList(param);
    }

    componentDidUpdate(prevProps) {
        // Kiểm tra nếu param đã thay đổi
        if (prevProps.param !== this.props.param) {
            console.log('Param has changed:', this.props.param);
            // Gọi lại API với param mới
            this.getBOTCommentList(this.props.param);
        }
    }

    getBOTCommentList(param) {
        var json = {
            userId: param
        }
        axios.post(global.config.apiDomain + '/rest/bot-manager/get-bot-recording', JSON.stringify(json), {
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(res => {
                console.log("List bot: " + res.data.recording);
                this.setState({
                    commentlist: res.data.recording
                });              
            })
    }

    handleCommentClick(param) {
        // Gọi hàm từ props và truyền param nếu cần
        this.props.onCommentClick(param);
        this.setState({
            recordingSelected: param
        })
    }

    lowerCaseAndRemoveAccents(original) {
        if (!original) return '';
        original = original.toLowerCase();
        original = original.replace(/\u0111/g, 'd');
        original = original.replace(/\u0110/g, 'd');
        original = original.normalize('NFD');
        original = original.replace(/[\u0300-\u036f]/g, ''); // Remove diacritics
        original = original.replace(/[^\w\s-]/g, ''); // Remove punctuation
        original = original.trim();
        original = original.replace(/\s+/g, '-'); // Replace spaces with "-"
        return original;
    }

    render() {
        const { param } = this.props;
        const { commentlist, recordingSelected } = this.state;
        const hasComment = commentlist && commentlist.length > 0;
        const getInitial = (text = "") => {
            const safeText = text || "";
            return safeText.trim().charAt(0).toUpperCase() || "U";
        };

        return (
            <div className="comment-feed-scroll">
                <div className="comment-feed-list">
                    {hasComment ? (
                        commentlist.map((record, index) => {
                            const isActive = record.id === recordingSelected;
                            const title = record.ownerName || "Người dùng";
                            const subtitle = record.recordingName || "Không có tiêu đề";
                            const avatarInitial = getInitial(title || subtitle);
                            const avatarSrc = (record.image || "").trim() ? record.image : DefaultAvatar;
                            const handleAvatarError = (event) => {
                                event.target.onerror = null;
                                event.target.src = DefaultAvatar;
                            };

                            const handleAvatarClick = (e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                const recordingId = record.recordingId || record.id || record._id;
                                const recordingName = record.recordingName || '';
                                if (recordingId) {
                                    const slug = this.lowerCaseAndRemoveAccents(recordingName);
                                    const url = slug 
                                        ? global.config.apiDomain + '/recording/' + slug + '-' + recordingId
                                        : global.config.apiDomain + '/recording/' + recordingId;
                                    window.open(url, '_blank');
                                }
                            };

                            return (
                                <button
                                    type="button"
                                    key={record.id || index}
                                    className={`comment-feed-item ${isActive ? "is-active" : ""}`}
                                    onClick={() => this.handleCommentClick(record.id)}
                                >
                                    <div className="comment-feed-text">
                                        <span className="comment-feed-title">{title}</span>
                                        <span className="comment-feed-subtitle">{subtitle}</span>
                                    </div>
                                    <div className="comment-feed-avatar">
                                        <img
                                            src={avatarSrc}
                                            alt={title}
                                            className="avatar"
                                            style={{ cursor: 'pointer' }}
                                            onClick={handleAvatarClick}
                                            onError={handleAvatarError}
                                        />
                                    </div>
                                </button>
                            );
                        })
                    ) : (
                        <div className="comment-feed-empty">
                            <i className="fa-regular fa-comments"></i>
                            <p>Chưa có bình luận để hiển thị</p>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
